'use client';

import CenteredLayout from '@local/common/ui/components/layout/CenteredLayout';
import { HeaderVariant } from '@local/common/ui/components/layout/Header/types';
import { HeaderMode } from '@local/common/ui/components/layout/Header';

export default function ErrorLayout({ children }: React.PropsWithChildren) {
    return (
        <CenteredLayout
            headerProps={{ variant: HeaderVariant.Secondary, mode: HeaderMode.Simple }}
            shouldShowFooter={false}
            dataTestId="error-centered-layout"
        >
            {children}
        </CenteredLayout>
    );
}
